// Truncates text to the specific limit but keeps the last matched word intact even if it exceeds the limit
const truncateText = (text: string, charLimit: number, suffix: string) => {
  const truncatedText = text.replace(
    new RegExp(`^(.{${charLimit}}[^\\s]*).*`),
    '$1'
  );
  const isLastCharFullStop =
    truncatedText.substring(truncatedText.length - 1) === '.';

  return isLastCharFullStop
    ? `${truncatedText.slice(0, -1)}${suffix}`
    : `${truncatedText}${suffix}`;
};

export default truncateText;
